<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">

  <!-- #region order details -->

  <div fxFlex="50">

      <mat-card class="content-card" style="">
        <mat-progress-bar mode="indeterminate" *ngIf="loadingOrder" class="progress-bar" style="margin-bottom: 10px;"></mat-progress-bar>
        <mat-card-header fxLayout="row" fxLayoutGap="10px">
          <mat-card-title>
            <h5>Total Card Order {{totalCardOrder?.id}}</h5>
          </mat-card-title>
          <div fxFlex></div>
          <div>
            <button mat-raised-button color="warn" *ngIf="currentUserIsAdmin()" [disabled]="cancelOrderDisabled()"
                    (click)="cancelOrder()">Cancel</button>  &nbsp;
            <!--<button mat-raised-button style="color: white; background-color: dodgerblue" *ngIf="currentUserIsAdmin()" [disabled]="cancelOrderDisabled()"
                    (click)="confirmOrder()">Confirm</button>-->
          </div>
        </mat-card-header>
        <mat-card-content class="mt-2">
          <span class="mr-2" *ngIf="!totalCardOrder && !loadingOrder">Order not exist/or has been removed</span>
          <span class="mr-2" *ngIf="loadingOrder">Loading...</span>

            <table class="list-table" *ngIf="totalCardOrder">

    <!--          <tr>
                <td class="secondary">ExternalRef</td>
                <td><label>{{ totalCardOrder.externalRef }}</label></td>
              </tr>
              <tr>
                <td class="secondary">Card Name</td>
                <td><label>{{ totalCardOrder.cardName }}</label></td>
              </tr>
              <tr>
                <td class="secondary">Invoice number</td>
                <td>
                  <label>
                    <a routerLink="/invoices/{{ totalCardOrder.invoiceId }}">{{ totalCardOrder.invoiceNumber }}</a>
                  </label>
                </td>
              </tr>
              <tr>
                <td class="secondary">Partner Customer ID</td>
                <td>
                  <label>
                    {{ totalCardOrder.partnerCustomerId }}
                  </label>
                </td>
              </tr>
    -->
              <tr *ngFor="let field of fields">
                <td class="secondary">{{ field.header }}</td>
                <td *ngIf="totalCardOrder"><label>{{ field.cell(totalCardOrder) }}</label></td>

              </tr>
              <ng-container *ngIf="totalCardOrder && totalCardOrder.cancellationReason != null">
                <tr *ngFor="let field of cancellationFields">
                  <td class="secondary"><label>{{ field.header }}</label></td>
                  <td *ngIf="totalCardOrder"><label>{{ field.cell(totalCardOrder) }}</label></td>
                </tr>
              </ng-container>
            </table>

        </mat-card-content>
        <mat-card-actions class="mt-2">

          <div fxFlex="50" align="start">
            <button
              title="Please verify invoice configuration settings or contact administrator for aditional support"
              mat-raised-button
              color="primary"
              (click)="downloadAttachment()"
              [disabled]="!totalCardOrder?.pdfFormId">
              {{totalCardOrder?.pdfFormId ? "Download PDF Form" : "PDF form not available"}}
            </button>
          </div>
          <div fxFlex="50" align="end" >
            <button mat-raised-button color="primary" [disabled]="!prevNext?.prev"
                    (click)="gotoPrevOrder()">Previous</button>
            <button mat-raised-button color="primary" [disabled]="!prevNext?.next" (click)="gotoNextOrder()">Next</button>
            <a mat-raised-button color="primary" (click)="returnBack()">Back</a>
            <a mat-raised-button color="primary" *ngIf="currentUserIsAdmin() && allowEditOrder()" routerLink="edit">Edit</a>
          </div>


        </mat-card-actions>
      </mat-card>
  </div>


  <div fxFlex="50">


    <app-object-comments-view *ngIf="totalCardOrder" [comments]="comments" [objectId]="totalCardOrder?.id" [target]="commentsTarget"></app-object-comments-view>


    <mat-card class="content-card" style="">
      <mat-progress-bar mode="indeterminate" *ngIf="loadingHistory" class="progress-bar mb-2"></mat-progress-bar>
      <mat-card-header fxLayout="row" fxLayoutGap="10px">
        <mat-card-title>
          <h5>Usage History</h5>
        </mat-card-title>
        <div fxFlex></div>
        <div>
          <!-- right button? -->
        </div>
      </mat-card-header>
      <mat-card-content class="mt-2">

        <mat-form-field>
          <mat-select placeholder="Select card" [(ngModel)]="selectedTotalCard" (selectionChange)="changeTotalStatCard()">
            <mat-option *ngFor="let totalCard of totalStatCards" [value]="totalCard">{{totalCard.registrationNumber}}</mat-option>
          </mat-select>
        </mat-form-field>

        <div *ngIf="selectedTotalCard">
          <mat-form-field>
            <mat-select placeholder="Select product" [(ngModel)]="selectedTotalProduct" (selectionChange)="changeTotalStatProduct()">
              <mat-option *ngFor="let totalProduct of totalStatCardProducts" [value]="totalProduct">{{totalProduct.productCode}} - {{totalProduct.productName}}</mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="selectedTotalProduct">

            <table>
              <tr>
                <td style="width: 100px;">Total amount excl</td>
                <td class="text-right">
                  <span  *ngIf="!loadingHistory">
                    {{ totalTotalProductAmountNet }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  Total quantity</td>
                <td class="text-right">
                  <span *ngIf="!loadingHistory">
                    {{ totalTotalProductQuantity }}
                  </span>
                </td>
              </tr>
            </table>

            <mat-table [dataSource]="totalStatTransactions">
              <ng-container matColumnDef="invoicingDate">
                <mat-header-cell *matHeaderCellDef> Inv. Date </mat-header-cell>
                <mat-cell *matCellDef="let txn"> {{txn.invoicingDate | date:'d.M.y'}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="time">
                <mat-header-cell *matHeaderCellDef> Txn Time </mat-header-cell>
                <mat-cell *matCellDef="let txn"> {{txn.transactionHour.toString().padStart(2, '0')}}:{{txn.transactionMinute.toString().padStart(2, '0')}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="product">
                <mat-header-cell *matHeaderCellDef> Product </mat-header-cell>
                <mat-cell *matCellDef="let txn"> {{selectedTotalProduct.productName}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="loc">
                <mat-header-cell *matHeaderCellDef> Location </mat-header-cell>
                <mat-cell *matCellDef="let txn"> {{txn.site.postCode}} {{txn.site.city}}, {{txn.site.countryName}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="qty">
                <mat-header-cell *matHeaderCellDef> Quantity </mat-header-cell>
                <mat-cell *matCellDef="let txn"> {{txn.quantity}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="amt_net">
                <mat-header-cell *matHeaderCellDef> Amount excl. </mat-header-cell>
                <mat-cell *matCellDef="let txn"> {{txn.priceExclVat}} </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="['invoicingDate', 'time', 'product', 'loc', 'qty', 'amt_net']"></mat-header-row>
              <mat-row *matRowDef="let row; columns: ['invoicingDate', 'time', 'product', 'loc', 'qty', 'amt_net']"></mat-row>

            </mat-table>
          </div>

        </div>

      </mat-card-content>
    </mat-card>

  </div>


  <!-- #endregion order details -->

  <!--<div fxFlex="50">-->

    <!-- #region card details -->

    <!-- TODO load cards or at least show customer...

    <mat-accordion class="mat-card">
      <mat-progress-bar mode="indeterminate" *ngIf="loadCardData" class="progress-bar"></mat-progress-bar>
      <mat-expansion-panel disabled=true>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Card
          </mat-panel-title>
          <mat-panel-title>
            Status
          </mat-panel-title>
          <mat-panel-title>
            Expiry date
          </mat-panel-title>
          <mat-panel-title>
            Last Payment Reminder
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
      <mat-expansion-panel *ngIf="card != null">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{card.product?.name}}
          </mat-panel-title>
          <mat-panel-title class=" {{card.status == 6 ? 'warning-row' : ''}}">
            {{card.statusName}}
          </mat-panel-title>
          <mat-panel-title>
            {{card.expireDate | date: 'dd.MM.yyyy'}}
          </mat-panel-title>
          <mat-panel-title>
            {{card.order.paymentEmailReminders && card.order.paymentEmailReminders[card.order.paymentEmailReminders.length - 1] | date: 'dd.MM.yyyy'}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="list-item" fxLayout="row" *ngFor="let field of cardFields;">
          <label fxFlex="35" class="secondary">
            {{ field.header }}
          </label>
          <label fxFlex="65" *ngIf="!(field.cell(card).startsWith('&lt;a') || field.cell(card).startsWith('&lt;i'))">
            {{ field.cell(card) }}
          </label>
          <label fxFlex="65" *ngIf="field.cell(card).startsWith('&lt;a')">
            <a [routerLink]="'../../' + field.cell(card).split(' ')[1]"
               [queryParams]="field.cell(card).split(' ')[2] != '|' ? {search: field.cell(card).split(' ')[2]} : null">
              {{ field.cell(card).split(' ')[3]}}
            </a>
          </label>
          <label fxFlex="65" *ngIf="field.cell(card).startsWith('&lt;i')">
            <a [routerLink]="'../../' + field.cell(card).split(' ')[1]"
               [queryParams]="field.cell(card).split(' ')[2] != '|' ? {search: field.cell(card).split(' ')[2]} : null">
              <mat-icon aria-label="View">visibility</mat-icon>
            </a>
          </label>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

-->

    <!-- #endregion card details -->

    <!-- #region sent reminders -->

    <!--<app-sent-reminders [orderId]="totalCardOrder"></app-sent-reminders>-->

    <!-- #endregion sent reminders -->

  <!--</div>-->
</div>
